const APP_ORIGIN = "https://folio.local";

export function safeAuthReturnTo(value: string | null): string {
  if (!value || value.length > 500 || !value.startsWith("/")) return "/";
  try {
    const target = new URL(value, APP_ORIGIN);
    if (target.origin !== APP_ORIGIN || target.pathname.startsWith("//")) return "/";
    return `${target.pathname}${target.search}${target.hash}`;
  } catch {
    return "/";
  }
}
